import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import AppBar from "../../Components/AppBar";
import MobilePage, { PageHeader } from "../../../Components/MobilePage";
import { Container } from "@material-ui/core";
import { Trans } from "react-i18next";
import OrderReceipt from "../../../Components/OrderReceipt/OrderReceipt";
import SharePictureSetsBox from "../../../Components/OrderReceipt/SharePictureSetsBox";
import Box from "@material-ui/core/Box/Box";
import { usePictureSets } from "../../../hooks/usePictureSets";

export default () => {
  const params = useParams();
  const { update } = usePictureSets();

  // When we bought digital picture sets, we need to make sure
  // the picture sets are updated
  useEffect(() => {
    update();
  }, []);

  return (
    <MobilePage>
      <AppBar />
      <PageHeader>
        <Trans>Thank you for the order!</Trans>
      </PageHeader>
      <Container maxWidth={"sm"}>
        <OrderReceipt orderUuid={params.orderUuid} />
        <Box mb={4}>
          <SharePictureSetsBox />
        </Box>
      </Container>
    </MobilePage>
  );
};
